import styled from '@emotion/styled'

import { Text } from '@cash-design-system/react'

import { Tokenizer } from '../createTokenizer/createTokenizer'

const TextLink = styled.a`
  color: inherit;
  text-decoration: underline;
  cursor: pointer;
`

const BreakAll = styled.span`
  word-break: break-all;
`

export const getUniqueKey = () => {
  // @ts-expect-error - borrowed code from https://github.com/WICG/uuid
  return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, (c: number) =>
    (c ^ (window?.crypto?.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))).toString(16)
  )
}

export const TokenizersRegex = {
  bold: /\*\*(.*?)\*\*/,
  email: /([a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+)/,
  link: /\[([^[\]]+)\]\(([^)]+)\)/,
  header: /##\s+(.*)/,
  phoneNumber: /(\([0-9]{3}\)\s[0-9]{3}-[0-9]{4})/,
  spacer: /[\n\r]/,
}

export const boldTextTokenizer: Tokenizer = {
  regex: TokenizersRegex.bold,
  toToken([_, text]: string[]) {
    const uniqueKey = getUniqueKey()
    return <strong key={`bold-${uniqueKey}`}>{text}</strong>
  },
}

export const emailTextTokenizer: Tokenizer = {
  regex: TokenizersRegex.email,
  toToken([email]) {
    const uniqueKey = getUniqueKey()
    return <BreakAll key={`email-${uniqueKey}`}>{email}</BreakAll>
  },
}

export const getTokenizerLinkProps = (href: string) => {
  if (href.startsWith('/') || href.startsWith(window.origin)) {
    return {}
  }
  return { target: '_blank', rel: 'noopener noreferrer' }
}

/**
 * NOTE: Do not use this with flows or journeys
 */
export const linkTokenizer: Tokenizer = {
  regex: TokenizersRegex.link,
  toToken: ([, text, href]: string[]) => {
    const uniqueKey = getUniqueKey()
    return (
      <TextLink href={href} key={`link-${uniqueKey}`} {...getTokenizerLinkProps(href)}>
        {text}
      </TextLink>
    )
  },
}

export const headerTokenizer: Tokenizer = {
  regex: TokenizersRegex.header,
  toToken([_, text]) {
    const uniqueKey = getUniqueKey()
    return (
      <Text key={`header-${uniqueKey}`} typography="titleBarPageTitle" color="textStandard" as="h2">
        {text}
      </Text>
    )
  },
}

export const preformattedPhoneNumberTokenizer: Tokenizer = {
  regex: TokenizersRegex.phoneNumber,
  toToken([preformattedPhoneNumber]) {
    const nonBreakingSpace = '\u00A0'
    return <>{preformattedPhoneNumber.replace(/\s/g, nonBreakingSpace)}</>
  },
}

export const spacerTokenizer: Tokenizer = {
  regex: TokenizersRegex.spacer,
  toToken() {
    return <br />
  },
}
